<div class="mt-4 bg-white border rounded-md">
  <ng-content></ng-content>
</div>
